module.exports = __webpack_public_path__ + "img/qidailaoyao.29637a46.jpg";